import { useQuery } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";

export default function useShopCustomCSS(shop: ShopDto) {
  const { data, isFetched } = $api.useQuery("get", "/shops/{shopId}/preferences/custom-css", {
    params: { path: { shopId: shop.id } },
  });

  return useQuery({
    queryKey: ["custom-css", shop!.id],
    queryFn: async () => {
      if (!data?.url) return "";
      const response = await fetch(data?.url);
      return response.text();
    },
    enabled: isFetched,
    retry: false,
  });
}
